import React, { PureComponent, Fragment } from 'react';
import { Modal, Button, Divider } from 'antd';
import { MODAL_ADD, MODAL_EDIT } from '../../appConstants';
import StandardTable from '../../components/StandardTable';
import UserInputForm from '../../components/UserInputForm';

class TenantUser extends PureComponent {
  state = {
    modalType: '',
    modalVisible: false,
    editingUser: {},
  };
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
  }

  onEdit = (data) => {
    const userId = this.state.editingUser.id;
    if (userId && data) this.props.editUser(userId, data);
  };

  handleEditClick = (user) => {
    this.handleModalVisible(MODAL_EDIT, true);
    this.setState({ editingUser: user });
  };

  handleDeleteClick = (user) => {
    Modal.confirm({
      title: 'Do you want to delete this user?',
      content: user.email,
      okText: 'Yes',
      okType: 'danger',
      onOk: () => {
        this.props.deleteUser(user.id);
      },
    });
  };

  handleModalVisible = (modalType, flag) => {
    this.setState({ modalType, modalVisible: flag });
  };

  render() {
    const { users, addUser } = this.props;
    const { modalType, modalVisible, editingUser } = this.state;
    const columns = [{
      title: 'Email',
      dataIndex: 'email',
    }, {
      title: 'Actions',
      dataIndex: 'actions',
      render: (text, record) => (
        <Fragment>
          <a className="btn-edit" onClick={() => { this.handleEditClick(record); }}>edit</a>
          <Divider type="vertical" />
          <a className="btn-delete" onClick={() => { this.handleDeleteClick(record); }}>delete</a>
        </Fragment>
      ),
    }];
    const data = users ? users.map(user => ({ key: user.id, ...user })) : [];


    return (
      <Fragment>
        <div className="operator" style={{ marginBottom: '1rem' }}>
          <Button className="btn-add" icon="plus" type="primary" onClick={() => { this.handleModalVisible(MODAL_ADD, true); }} >Add</Button>
        </div>
        <StandardTable columns={columns} data={data} />
        <UserInputForm
          modalType={modalType}
          modalVisible={modalVisible}
          handleModalVisible={this.handleModalVisible}
          editingUser={editingUser || null}
          handleSubmit={modalType === MODAL_ADD ? addUser : this.onEdit}
        />
      </Fragment>
    );
  }
}

export default TenantUser;



// WEBPACK FOOTER //
// ./src/routes/TenantUser/TenantUser.js